import React from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";
import "../css/privacy.scss";

const CookiePolicy = () => (
  <PolicyLayout
    eyebrow="Your choices"
    title="Cookie & browser storage policy"
    lede={`The browser storage used by ${siteConfig.brandName}, why it is used, and how you can control it.`}
    nav={[
      { href: "#what", label: "What we use" },
      { href: "#storage", label: "Storage details" },
      { href: "#third-party", label: "Third parties" },
      { href: "#controls", label: "Your controls" },
    ]}
  >
    <section className="policy-section" id="what">
      <p className="editorial-page__section-label">01</p>
      <h2>Cookies and local storage</h2>
      <p>
        Cookies are small values a website can ask a browser to store and send
        with later requests. Local storage is a separate browser feature that
        keeps data on your device. This storefront currently uses first-party
        local storage—not advertising cookies—to keep your shopping bag and saved
        items available between pages and visits.
      </p>
    </section>

    <section className="policy-section" id="storage">
      <p className="editorial-page__section-label">02</p>
      <h2>Storage currently used by this storefront</h2>
      <div className="privacy-data-list">
        <article>
          <h3><code>ierryhouse:cart</code></h3>
          <p>
            Stores product identifiers, selected options, and quantities needed
            to keep your shopping bag. It remains until you empty the bag, clear
            site data, or your browser removes it.
          </p>
        </article>
        <article>
          <h3><code>ierryhouse:wishlist</code></h3>
          <p>
            Stores product identifiers for your saved list. It remains until you
            remove the items, clear site data, or your browser removes it.
          </p>
        </article>
      </div>
      <p>
        This storage is used for requested shopping features. It does not contain
        your name, email, postal address, full payment credentials, or the content
        of customer-care messages.
      </p>
    </section>

    <section className="policy-section" id="analytics">
      <p className="editorial-page__section-label">03</p>
      <h2>Analytics and advertising</h2>
      <p>
        We do not currently set analytics or advertising cookies through this
        storefront, and we do not use its local storage for cross-site behavioral
        advertising. If that changes, we will update this policy and introduce
        any notice or consent choice required before using non-essential storage.
      </p>
    </section>

    <section className="policy-section" id="third-party">
      <p className="editorial-page__section-label">04</p>
      <h2>Payment and other third-party services</h2>
      <p>
        When you continue to the external payment page or follow a third-party
        link, that provider may use cookies or similar technology for security,
        session management, fraud prevention, preferences, or other purposes
        described in its own notice. Those technologies are controlled by the
        provider on its service, not by this storefront.
      </p>
    </section>

    <section className="policy-section" id="controls">
      <p className="editorial-page__section-label">05</p>
      <h2>Your browser controls</h2>
      <p>
        You can inspect, block, or clear site data through browser privacy
        settings. Blocking local storage may cause the bag and saved list to
        reset or stop persisting between pages. Private-browsing modes may remove
        the data automatically when the session ends.
      </p>
      <p>
        Because this storefront does not currently use behavioral-advertising
        trackers, it does not respond differently to “Do Not Track” or similar
        browser signals. Any legally required universal opt-out signal will be
        honored if processing covered by that signal is introduced.
      </p>
    </section>

    <section className="policy-section" id="changes">
      <p className="editorial-page__section-label">06</p>
      <h2>Updates and questions</h2>
      <p>
        We will revise this policy if storage practices change. For questions,
        email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>{" "}
        or read our <Link to="/privacy">privacy policy</Link> for information
        about personal data.
      </p>
    </section>
  </PolicyLayout>
);

export default CookiePolicy;
